/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmParameter {
    getFixupPrototypeFunction() { return AwsSsmParameter.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmParameter>): AwsSsmParameter {
        let obj = Object.assign(new AwsSsmParameter(), model);
        AwsSsmParameter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmParameter>): AwsSsmParameter {
        if (!model) return null;
        return AwsSsmParameter.newInstance(<AwsSsmParameter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmParameter) {
        if (!obj) return;

        models.AwsSsmParameter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmParameter): boolean {
        Object.setPrototypeOf(obj, AwsSsmParameter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.min_items === undefined) {
            this.min_items = 0;
        }
        if (this.max_items === undefined) {
            this.max_items = 0;
        }
        if (this.min_chars === undefined) {
            this.min_chars = 0;
        }
        if (this.max_chars === undefined) {
            this.max_chars = 0;
        }
    }

    /**
     * The name of the parameter
     */
    name: string;

    /**
     * Type of the parameter of automation documents
     */
    type: models.AwsSsmDocumentParameterType;

    /**
     * The description of the parameters
     */
    description: string;

    /**
     * The default values for the parameters
     */
    default_value: string;

    /**
     * Minimum number items in parameter
     */
    min_items: number;

    /**
     * Maximum number items in parameter
     */
    max_items: number;

    /**
     * List of allowed values
     */
    allowed_values: Array<string>;

    /**
     * Type of display items
     */
    display_type: string;

    /**
     * Regex patterns of the parameter
     */
    allowed_pattern: string;

    /**
     * Minimum number of characters in the parameters
     */
    min_chars: number;

    /**
     * Maximum number of characters in the parameters
     */
    max_chars: number;

}
